import { ref } from 'vue';
import { useWalletStore } from '@/store/wallet';
import { Apii } from '@/services/api.js';
import { notify } from 'notiwind';

export function useMissingCardRequest() {
    const ApiService = new Apii();
    const walletStore = useWalletStore();

    const showMissingCardModal = ref(false);
    const missingCardBank = ref('');
    const missingCardName = ref('');
    const missingCardStep = ref(0);
    const tempHideEditModal = ref(false);

    const openMissingCardModal = () => {
        tempHideEditModal.value = true;
        showMissingCardModal.value = true;
    };

    const closeMissingCardModal = () => {
        showMissingCardModal.value = false;
        missingCardStep.value = 0;
        missingCardBank.value = '';
        missingCardName.value = '';
        tempHideEditModal.value = false;
    };

    const submitMissingCardRequest = async (userId) => {
        try {
            const data = {
                user: userId,
                manualCard: {
                    chosenCard: null,
                    type: 'personal',
                    card_not_found: true,
                    card_not_found_name: missingCardName.value,
                    card_not_found_bank: missingCardBank.value,
                    last_four: '',
                    dateOpened: '',
                    accountType: '',
                    bonusAmount: 0,
                    minSpendDate: '',
                    bonusReceived: '',
                    dateReceived: '',
                    cardStatus: 'open',
                    dateClosed: '',
                    creditLimit: 0,
                    annualFee: 0,
                    dateBonusEarned: '',
                    currentRewardsBalance: '',
                    institution_code: '',
                    opened_long_ago: false,
                    closed_long_ago: false,
                    business_id: null,
                },
                welcome_bonus: {
                    type: null,
                    minimum_spend_deadline: null,
                    minimum_spend_amount: null,
                    bonus_amount: null,
                    bonus_units: '',
                    received: null,
                    date_received: null,
                },
                tiered_bonuses: [],
            };

            await ApiService.apiCall(
                `/wallets/${walletStore.wallet.id}/cards`,
                'post',
                data
            );

            missingCardStep.value = 1;

            notify({
                group: 'success',
                title: 'Card request submitted',
                text: "We'll review your request and add the card as soon as possible.",
                type: 'success',
            });
        } catch (error) {
            notify({
                group: 'error',
                title: 'Error',
                text:
                    error?.response?.data?.message ||
                    'Failed to submit card request. Please try again.',
                type: 'error',
            });
        }
    };

    return {
        showMissingCardModal,
        missingCardBank,
        missingCardName,
        missingCardStep,
        tempHideEditModal,
        openMissingCardModal,
        closeMissingCardModal,
        submitMissingCardRequest,
    };
}
